'use client'

import { useState } from 'react'

import { Button } from '@wartek-id/button'
import { Icon } from '@wartek-id/icon'
import { Text } from '@wartek-id/text'

import {
  trackClickOpenWilayahDialog,
  trackClickSelectWilayah,
} from '@/utils/tracker/modules/dataset'
import { District, DistrictResponse, RQStatus } from '@/apis/types'

import { WilayahSelectionResponsive } from '../WilayahSelection/WilayahSelectionResponsive'

interface FilterWilayahProps {
  value: District | null
  onChange: (d: District) => void
  data?: DistrictResponse
  loadingStatus: RQStatus
}

export const FilterWilayah = ({
  value,
  onChange,
  loadingStatus,
  data,
}: FilterWilayahProps) => {
  const [isShowWilayahDialog, setIsShowWilayahDialog] = useState<boolean>(false)

  const handleOpenWilayahDialog = () => {
    setIsShowWilayahDialog(true)
    trackClickOpenWilayahDialog()
  }

  const handleCloseWilayahDialog = () => {
    setIsShowWilayahDialog(false)
  }

  const handleSelectWilayah = (newWilayah) => {
    if (newWilayah) {
      trackClickSelectWilayah(newWilayah?.id)
    }
    setIsShowWilayahDialog(false)
    onChange(newWilayah)
  }

  return (
    <div className="flex w-full flex-col gap-2 md:flex-row md:items-center">
      <Text variant="body-sm-bold">Wilayah</Text>
      <div className="w-full md:max-w-[200px]">
        <Button
          color="white"
          className="flex !justify-between gap-2 !px-[16px] !py-[10px] !font-normal"
          fullWidth
          onClick={handleOpenWilayahDialog}
          disabled={loadingStatus === 'pending'}
          isLoading={loadingStatus === 'pending'}
          data-value-name={value?.name}
          data-value-id={value?.id}
          data-testid="btn-filter-wilayah"
        >
          <Text className="truncate">{value?.name || 'Pilih Wilayah'}</Text>
          <Icon>expand_more</Icon>
        </Button>
      </div>

      <WilayahSelectionResponsive
        data={data?.data || []}
        show={isShowWilayahDialog}
        onClose={handleCloseWilayahDialog}
        onSelect={handleSelectWilayah}
      />
    </div>
  )
}
